<template>
<div>
    <div v-if="loading" class="loading-spin">
        <SpinnerLoader :color="'#3c5d3d'" />
    </div>
    <div v-else :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2', 'color' : data.impairedRegime ? '#000000' : '#333333'}" class="outer flex-col">
        <directory style="margin-left: 8%" :route="$route"></directory>
        <div class="top-header flex-row">
            <h1 v-if="lang === 'ru'">Новости</h1>
            <h1 v-if="lang === 'kk'">Жаңалықтар</h1>
            <div class="search">
                <div class="search-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                    </svg>
                </div>
                <input v-if="lang === 'ru'" v-model="search_text" :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#f2f2f2'}" class="on" type="text" placeholder="Поиск по новостям">
                <input v-if="lang === 'kk'" v-model="search_text" :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#f2f2f2'}" class="on" type="text" placeholder="Жаңалықтар бойынша іздеу">
                <!-- <div class="calendar-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.3004 1.8H14.4004V0H12.6004V1.8H5.40039V0H3.60039V1.8H2.70039C1.71039 1.8 0.900391 2.61 0.900391 3.6V16.2C0.900391 17.19 1.71039 18 2.70039 18H15.3004C16.2904 18 17.1004 17.19 17.1004 16.2V3.6C17.1004 2.61 16.2904 1.8 15.3004 1.8ZM15.3004 16.2H2.70039V6.3H15.3004V16.2Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                        <path d="M9 8.09961H4.5V12.5996H9V8.09961Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                    </svg>
                </div> -->
            </div>
        </div>
        <h3 v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#EB5757' }">Топ новости</h3>
        <h3 v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#EB5757' }">Басты жаңалықтар</h3>
        <div v-if="dataNews" :style="{ 'filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="news-list flex-row">
            <div @click="$router.push({ name: 'single-news', params: { id: news.id, title: news.attributes.title } })" v-for="news in dataNews.filter( item => dataNews.indexOf(item) < 4 )" :key="news.id" :style="{ 'background-image' : news.relationships.field_cover_image.data ? 'url(' + url + dataIncluded.find( item => item.type === 'file--file' && item.id === news.relationships.field_cover_image.data.id ).attributes.uri.url + ')' : 'white' }" class="item">
                <!-- <div class="cat">{{ dataIncluded.find( item => item.id === news.relationships.field_tags.data.find( x => x.id !== 'f2a351e1-6046-4d61-823d-25fb6e965225' ).id ).attributes.name }}</div> -->
                <div class="text">
                    <h5>{{ news.attributes.title }}</h5>
                    <p>{{ news.attributes.field_short_description }}</p>
                </div>
            </div>
        </div>
        <h3 v-if="lang === 'ru'">Все новости</h3>
        <h3 v-if="lang === 'kk'">Барлық жаңалықтар</h3>
        <div v-if="dataNews" class="all-news flex-row">
            <div :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#F0DCC4', 'color' : data.impairedRegime ? '#000000' : '#333333'}" @click="$router.push({ name: 'single-news', params: { id: news.id } })" v-for="news in dataNews.filter( item => dataNews.indexOf(item) < newsNum )" :key="news.id" class="item flex-col">
                <h5 class="author">{{ dataIncluded.find( item => item.id === news.relationships.uid.data.id ).attributes.name }}</h5>
                <span class="date">{{ formatDateTime( news.attributes.created ) }}</span>
                <h4 :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }" class="name">{{ news.attributes.title }}</h4>
                <p>{{ news.attributes.field_short_description }}</p>
            </div>
            <!-- <div @click="$router.push({ name: 'single-news', params: { id: '1' } })" v-for="index in 8" :key="index" class="item flex-col">
                <h5 class="author">Карина М., 18 лет </h5>
                <span class="date">19.07.2020</span>
                <h4 class="name">Название</h4>
                <p>Однажды у нас заночевал друг отца. И... Однажды у нас заночевал друг отца. И... Однажды у нас заночевал друг отца.И...Однажды у нас заночевал друг отца. И...Однажды у нас заночевал друг отца. И...Однажды у нас заночевал друг отца...</p>
            </div> -->
        </div>
        <div v-if="dataNews.length > newsNum && lang === 'ru'" @click="newsNum += 6" class="load-more">Загрузить еще</div>
        <div v-if="dataNews.length > newsNum && lang === 'kk'" @click="newsNum += 6" class="load-more">Тағы да жүктеу</div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { func, api } from '../../variables.js'

export default {
    props: [ 'data' ],
    data(){
        return {
            search_text: '',
            dataNews: '',
            dataAllNews: '',
            dataIncluded: '',
            url : api,
            newsNum: 3,
            lang: 'kk',
            loading: false
        }
    },
    created(){
        window.scrollTo(0,0)
        if( localStorage.getItem('xyzCustomLang') ){
			this.lang = localStorage.getItem('xyzCustomLang')
        }
        this.getNews()
    },
    watch: {
        search_text: function(text) {
            text = text.toLowerCase().split(' ');
            this.dataNews = this.dataAllNews.filter(function(item) {
                return text.every(function(el) {
                    return item.attributes.title.toLowerCase().indexOf(el) > -1;
                });
            });
        }
    },
    methods: {
        getNews(){
            this.loading = true
            axios.get( api + '/mhealth/jsonapi/node/srh_content/?filter[field_country.name]=KAZ&filter[langcode]=' + this.lang + '&sort=-created&page[offset]=0&page[limit]=100&filter[field_tags.name]=newsKZ&include=uid,uid.user_picture,field_cover_image,field_tags' )
            .then((res) => {
                // console.log( res.data.data)
                this.dataNews = res.data.data
                this.dataAllNews = res.data.data
                this.dataIncluded = res.data.included
                this.loading = false
            })
            .catch((e) => {
                this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
        formatDateTime: func.formatDateTime,
    }
}
</script>
<style scoped lang="scss">
    *{
        transition: all 0.6s ease;
    }
    h1, h3, h4, h5, p, span, a, label{
        cursor: default;
        text-decoration: none;
        text-align: left;
        margin: 0;
    }
    .outer{
        position: relative;
        padding: 34px 0 47px 0;
        transition: none;
        .top-header{
            position: relative;
            margin: 0 8%;
            h1{
                font-weight: 500;
                font-size: 34px;
                line-height: 45px;
                letter-spacing: 0.04em;
            }
            .search{
                position: absolute;
                right: 0;
                top: 0;
                .search-icon{
                    cursor: pointer;
                    position: absolute;
                    left: 19px;
                    top: 19px;
                    opacity: 0.6;
                }
                .calendar-icon{
                    cursor: pointer;
                    position: absolute;
                    right: 19px;
                    top: 19px;
                    opacity: 0.6;
                }
                .on{
                    width: 530px;
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 10px;
                    border: 1px solid #f2f2f2;
                    padding: 14px 15px 14px 60px;
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 18px;
                    transition: width 0.5s;
                }
                input::placeholder{
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 18px;
                    opacity: 0.6;
                }
            }
        }
        h3{
            margin: 52px 8% 0 8%;
            font-weight: bold;
            font-size: 24px;
            line-height: 26px;
            letter-spacing: 0.04em;
        }
        .news-list{
            margin: 30px 8% 18px 8%;
            width: 92%;
            overflow-x: scroll;
            .item{
                cursor: pointer;
                flex: 0 0 auto;
                position: relative;
                margin-right: 30px;
                height: 460px;
                width: 485px;
                background: center no-repeat;
                background-size: cover;
                border-radius: 10px;
                // border: 1px solid rgba(86, 105, 126, 0.7);
                .cat{
                    position: absolute;
                    top: 20px;
                    left: 20px;
                    padding: 7px 15px;
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 26px;
                    letter-spacing: 0.04em;
                    color: #FFFFFF;
                    background: #EB5757;
                    box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                    border-radius: 10px
                }
                .text{
                    width: 385px;
                    position: absolute;
                    bottom: 0;
                    height: 105px;
                    background: rgba(86, 105, 126, 0.7);
                    backdrop-filter: blur(14px);
                    border-radius: 0px 0px 10px 10px;
                    padding: 20px 50px;
                    h5, p{
                        cursor: pointer;
                        text-align: left;
                        margin: 0;
                    }
                    h5{
                        height: 30px;
                        text-overflow: ellipsis;
						overflow: hidden; 
						white-space: nowrap;
                        font-weight: bold;
                        font-size: 20px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                        color: #FFFFFF;
                    }
                    p{
                        height: 65px;
                        text-overflow: ellipsis;
						overflow: hidden; 
						white-space: nowrap;
                        margin-top: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 22px;
                        letter-spacing: 0.05em;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .all-news{
            margin: 30px 8% 0 8%;
            flex-wrap: wrap;
            width: 84%;
            .item{
                cursor: pointer;
                position: relative;
                width: calc(31% - 40px);
                margin: 0 3.5% 30px 0;
                padding: 20px;
                box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                border-radius: 10px;
                h5{
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 30px;
                    letter-spacing: 0.05em;
                }
                .date{
                    cursor: pointer;
                    position: absolute;
                    right: 20px;
                    top: 20px;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 30px;
                    letter-spacing: 0.15em;
                    
                }
                .name{
                    cursor: pointer;
                    margin-top: 30px;
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.05em;
                }
                p{
                    cursor: pointer;
                    margin-top: 10px;
                    font-weight: 500;
                    height: 154px;
                    font-size: 16px;
                    line-height: 26px;
                    letter-spacing: 0.04em;
                    display: -webkit-box;
                    -webkit-line-clamp: 6;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .item:nth-of-type(3n){
                margin-right: 0;
            }
            .item:hover{
                p, h4, h5, span{
                    cursor: pointer;
                }
                cursor: pointer;
                background: #F6F4EB;
            }
        }
        .load-more{
            cursor: pointer;
            margin: 0 auto;
            padding: 15px 130px;
            font-weight: 500;
            font-size: 16px;
            line-height: 26px;
            text-align: center;
            letter-spacing: 0.04em;
            color: #FFFFFF;
            background: #568357;
            box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
            border-radius: 10px;
        }
    }
    @media only screen and (max-width: 1330px){
        .outer{
            position: relative;
            padding: 34px 0 47px 0;
            .top-header{
                position: relative;
                margin: 0 6%;
                h1{
                    font-weight: 500;
                    font-size: 34px;
                    line-height: 45px;
                    letter-spacing: 0.04em;
                }
                .search{
                    position: absolute;
                    right: 0;
                    top: 0;
                    .search-icon{
                        cursor: pointer;
                        position: absolute;
                        left: 19px;
                        top: 19px;
                        opacity: 0.6;
                    }
                    .calendar-icon{
                        cursor: pointer;
                        position: absolute;
                        right: 19px;
                        top: 19px;
                        opacity: 0.6;
                    }
                    .on{
                        width: 530px;
                        height: 28px;
                        background: #FFFFFF;
                        border-radius: 10px;
                        border: 1px solid #f2f2f2;
                        padding: 14px 15px 14px 60px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        transition: width 0.5s;
                    }
                    input::placeholder{
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        opacity: 0.6;
                    }
                }
            }
            h3{
                margin: 36px 6% 0 6%;
                font-weight: bold;
                font-size: 24px;
                line-height: 26px;
                letter-spacing: 0.04em;
            }
            .news-list{
                margin: 30px 6% 18px 6%;
                width: 94%;
                overflow-x: scroll;
                .item{
                    cursor: pointer;
                    flex: 0 0 auto;
                    position: relative;
                    margin-right: 30px;
                    height: 320px;
                    width: 360px;
                    background: center no-repeat;
                    border-radius: 10px;
                    .cat{
                        position: absolute;
                        top: 20px;
                        left: 20px;
                        padding: 7px 15px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        color: #FFFFFF;
                        background: #EB5757;
                        box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                        border-radius: 10px
                    }
                    .text{
                        width: 300px;
                        position: absolute;
                        bottom: 0;
                        height: 105px;
                        background: rgba(86, 105, 126, 0.7);
                        backdrop-filter: blur(14px);
                        border-radius: 0px 0px 10px 10px;
                        padding: 15px 30px;
                        h5, p{
                            cursor: pointer;
                            text-align: left;
                            margin: 0;
                        }
                        h5{
                            height: 30px;
                            text-overflow: ellipsis;
                            overflow: hidden; 
                            white-space: nowrap;
                            font-weight: bold;
                            font-size: 20px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                            color: #FFFFFF;
                        }
                        p{
                            height: 65px;
                            text-overflow: ellipsis;
                            overflow: hidden; 
                            white-space: nowrap;
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 22px;
                            letter-spacing: 0.05em;
                            color: #FFFFFF;
                        }
                    }
                }
            }
            .all-news{
                margin: 30px 6% 0 6%;
                flex-wrap: wrap;
                width: 88%;
                .item{
                    cursor: pointer;
                    position: relative;
                    width: calc(32% - 30px);
                    margin: 0 2% 30px 0;
                    padding: 10px 15px;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    h5{
                        cursor: pointer;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    .date{
                        cursor: pointer;
                        position: absolute;
                        right: 15px;
                        top: 10px;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 30px;
                    }
                    .name{
                        cursor: pointer;
                        margin-top: 30px;
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    p{
                        cursor: pointer;
                        margin-top: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                    }
                }
                .item:nth-of-type(3n){
                    margin-right: 0;
                }
                .item:hover{
                    p, h4, h5, span{
                        cursor: pointer;
                    }
                    cursor: pointer;
                    background: #F6F4EB;
                }
            }
            .load-more{
                cursor: pointer;
                margin: 0 auto;
                padding: 15px 130px;
                font-weight: 500;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                letter-spacing: 0.04em;
                color: #FFFFFF;
                background: #568357;
                box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                border-radius: 10px;
            }
        }
    }
    @media only screen and (max-width: 1024px){
        .outer{
            position: relative;
            padding: 34px 0 47px 0;
            .top-header{
                position: relative;
                margin: 0 6%;
                h1{
                    font-weight: 500;
                    font-size: 28px;
                    line-height: 38px;
                    letter-spacing: 0.04em;
                }
                .search{
                    position: absolute;
                    right: 0;
                    top: 0;
                    .search-icon{
                        cursor: pointer;
                        position: absolute;
                        left: 19px;
                        top: 19px;
                        opacity: 0.6;
                    }
                    .calendar-icon{
                        cursor: pointer;
                        position: absolute;
                        right: 19px;
                        top: 19px;
                        opacity: 0.6;
                    }
                    .on{
                        width: 330px;
                        height: 28px;
                        background: #FFFFFF;
                        border-radius: 10px;
                        border: 1px solid #f2f2f2;
                        padding: 14px 15px 14px 60px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        transition: width 0.5s;
                    }
                    input::placeholder{
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        opacity: 0.6;
                    }
                }
            }
            h3{
                margin: 36px 6% 0 6%;
                font-weight: bold;
                font-size: 24px;
                line-height: 26px;
                letter-spacing: 0.04em;
            }
            .news-list{
                margin: 30px 6% 18px 6%;
                width: 94%;
                overflow-x: scroll;
                .item{
                    cursor: pointer;
                    flex: 0 0 auto;
                    position: relative;
                    margin-right: 30px;
                    height: 260px;
                    width: 300px;
                    background: center no-repeat;
                    border-radius: 10px;
                    .cat{
                        position: absolute;
                        top: 10px;
                        left: 15px;
                        padding: 4px 12px;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        color: #FFFFFF;
                        background: #EB5757;
                        box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                        border-radius: 10px
                    }
                    .text{
                        width: 260px;
                        position: absolute;
                        bottom: 0;
                        height: 105px;
                        background: rgba(86, 105, 126, 0.7);
                        backdrop-filter: blur(14px);
                        border-radius: 0px 0px 10px 10px;
                        padding: 10px 20px;
                        h5, p{
                            cursor: pointer;
                            text-align: left;
                            margin: 0;
                        }
                        h5{
                            height: 30px;
                            text-overflow: ellipsis;
                            overflow: hidden; 
                            white-space: nowrap;
                            font-weight: bold;
                            font-size: 20px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                            color: #FFFFFF;
                        }
                        p{
                            height: 65px;
                            text-overflow: ellipsis;
                            overflow: hidden; 
                            white-space: nowrap;
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 22px;
                            letter-spacing: 0.05em;
                            color: #FFFFFF;
                        }
                    }
                }
            }
            .all-news{
                margin: 30px 6% 0 6%;
                flex-wrap: wrap;
                width: 88%;
                .item{
                    cursor: pointer;
                    position: relative;
                    width: calc(49% - 30px);
                    margin: 0 2% 20px 0;
                    padding: 10px 15px;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    h5{
                        cursor: pointer;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    .date{
                        cursor: pointer;
                        position: absolute;
                        right: 15px;
                        top: 10px;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 30px;
                    }
                    .name{
                        cursor: pointer;
                        margin-top: 30px;
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    p{
                        cursor: pointer;
                        margin-top: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                    }
                }
                .item:nth-of-type(3n){
                    margin-right: 2%;
                }
                .item:nth-of-type(2n){
                    margin-right: 0;
                }
                .item:hover{
                    p, h4, h5, span{
                        cursor: pointer;
                    }
                    cursor: pointer;
                    background: #F6F4EB;
                }
            }
            .load-more{
                cursor: pointer;
                margin: 0 auto;
                padding: 15px 130px;
                font-weight: 500;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                letter-spacing: 0.04em;
                color: #FFFFFF;
                background: #568357;
                box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                border-radius: 10px;
            }
        }
    }
    @media only screen and (max-width: 720px){
        .outer{
            position: relative;
            padding: 34px 0 47px 0;
            .top-header{
                position: relative;
                margin: 0 6%;
                h1{
                    font-weight: 500;
                    font-size: 26px;
                    line-height: 38px;
                    letter-spacing: 0.04em;
                }
                .search{
                    position: absolute;
                    right: 0;
                    top: 0;
                    .search-icon{
                        cursor: pointer;
                        position: absolute;
                        left: 19px;
                        top: 15px;
                        opacity: 0.6;
                    }
                    .calendar-icon{
                        cursor: pointer;
                        position: absolute;
                        right: 19px;
                        top: 15px;
                        opacity: 0.6;
                    }
                    .on{
                        width: 200px;
                        height: 28px;
                        background: #FFFFFF;
                        border-radius: 10px;
                        border: 1px solid #f2f2f2;
                        padding: 8px 40px 8px 50px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        transition: width 0.5s;
                    }
                    input::placeholder{
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        opacity: 0.6;
                    }
                }
            }
            h3{
                margin: 20px 6% 0 6%;
                font-weight: bold;
                font-size: 22px;
                line-height: 26px;
                letter-spacing: 0.04em;
            }
            .news-list{
                margin: 30px 6% 18px 6%;
                width: 94%;
                overflow-x: scroll;
                .item{
                    cursor: pointer;
                    flex: 0 0 auto;
                    position: relative;
                    margin-right: 30px;
                    height: 180px;
                    width: 200px;
                    background: center no-repeat;
                    border-radius: 10px;
                    .cat{
                        position: absolute;
                        top: 10px;
                        left: 15px;
                        padding: 0px 12px;
                        font-weight: 300;
                        font-size: 12px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        color: #FFFFFF;
                        background: #EB5757;
                        box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                        border-radius: 6px;
                    }
                    .text{
                        width: 176px;
                        position: absolute;
                        bottom: 0;
                        height: 85px;
                        background: rgba(86, 105, 126, 0.7);
                        backdrop-filter: blur(14px);
                        border-radius: 0px 0px 10px 10px;
                        padding: 4px 12px;
                        h5, p{
                            cursor: pointer;
                            text-align: left;
                            margin: 0;
                        }
                        h5{
                            height: 30px;
                            text-overflow: ellipsis;
                            overflow: hidden; 
                            white-space: nowrap;
                            font-weight: bold;
                            font-size: 16px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                            color: #FFFFFF;
                        }
                        p{
                            height: 50px;
                            text-overflow: ellipsis;
                            overflow: hidden; 
                            white-space: nowrap;
                            margin-top: 4px;
                            font-weight: 500;
                            font-size: 14px;
                            line-height: 16px;
                            letter-spacing: 0.05em;
                            color: #FFFFFF;
                        }
                    }
                }
            }
            .all-news{
                margin: 20px 6% 0 6%;
                flex-wrap: wrap;
                width: 88%;
                .item{
                    cursor: pointer;
                    position: relative;
                    width: calc(100%);
                    margin: 0 0 20px 0;
                    padding: 6px 12px;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    h5{
                        cursor: pointer;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    .date{
                        cursor: pointer;
                        position: absolute;
                        right: 12px;
                        top: 6px;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 30px;
                    }
                    .name{
                        cursor: pointer;
                        margin-top: 30px;
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    p{
                        cursor: pointer;
                        margin-top: 4px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                    }
                }
                .item:nth-of-type(3n){
                    margin-right: 0;
                }
                .item:nth-of-type(2n){
                    margin-right: 0;
                }
                .item:hover{
                    p, h4, h5, span{
                        cursor: pointer;
                    }
                    cursor: pointer;
                    background: #F6F4EB;
                }
            }
            .load-more{
                cursor: pointer;
                margin: 0 auto;
                padding: 15px 50px;
                font-weight: 500;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                letter-spacing: 0.04em;
                color: #FFFFFF;
                background: #568357;
                box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                border-radius: 10px;
            }
        }
    }
    @media only screen and (max-width: 480px){
        .outer{
            position: relative;
            padding: 24px 0 36px 0;
            .top-header{
                position: relative;
                margin: 0 4%;
                h1{
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 38px;
                    letter-spacing: 0.04em;
                }
                .search{
                    display: none;
                    position: absolute;
                    right: 0;
                    top: 0;
                    .search-icon{
                        cursor: pointer;
                        position: absolute;
                        left: 19px;
                        top: 15px;
                        opacity: 0.6;
                    }
                    .calendar-icon{
                        cursor: pointer;
                        position: absolute;
                        right: 19px;
                        top: 15px;
                        opacity: 0.6;
                    }
                    .on{
                        width: 200px;
                        height: 28px;
                        background: #FFFFFF;
                        border-radius: 10px;
                        border: 1px solid #f2f2f2;
                        padding: 8px 40px 8px 50px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        transition: width 0.5s;
                    }
                    input::placeholder{
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        opacity: 0.6;
                    }
                }
            }
            h3{
                margin: 6px 4% 0 4%;
                font-weight: bold;
                font-size: 18px;
                line-height: 26px;
                letter-spacing: 0.04em;
            }
            .news-list{
                margin: 20px 4% 18px 4%;
                width: 94%;
                overflow-x: scroll;
                .item{
                    cursor: pointer;
                    flex: 0 0 auto;
                    position: relative;
                    margin-right: 16px;
                    height: 180px;
                    width: 160px;
                    background: center no-repeat;
                    border-radius: 10px;
                    .cat{
                        position: absolute;
                        top: 10px;
                        left: 15px;
                        padding: 0px 12px;
                        font-weight: 300;
                        font-size: 12px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        color: #FFFFFF;
                        background: #EB5757;
                        box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                        border-radius: 6px;
                    }
                    .text{
                        width: 136px;
                        position: absolute;
                        bottom: 0;
                        height: 85px;
                        background: rgba(86, 105, 126, 0.7);
                        backdrop-filter: blur(14px);
                        border-radius: 0px 0px 10px 10px;
                        padding: 4px 12px;
                        h5, p{
                            cursor: pointer;
                            text-align: left;
                            margin: 0;
                        }
                        h5{
                            height: 30px;
                            text-overflow: ellipsis;
                            overflow: hidden; 
                            white-space: nowrap;
                            font-weight: bold;
                            font-size: 16px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                            color: #FFFFFF;
                        }
                        p{
                            height: 50px;
                            text-overflow: ellipsis;
                            overflow: hidden; 
                            white-space: nowrap;
                            margin-top: 4px;
                            font-weight: 500;
                            font-size: 12px;
                            line-height: 16px;
                            letter-spacing: 0.05em;
                            color: #FFFFFF;
                        }
                    }
                }
            }
            .all-news{
                margin: 20px 4% 0 4%;
                flex-wrap: wrap;
                width: 92%;
                .item{
                    cursor: pointer;
                    position: relative;
                    width: calc(100%);
                    margin: 0 0 20px 0;
                    padding: 6px 12px;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    h5{
                        cursor: pointer;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    .date{
                        cursor: pointer;
                        position: absolute;
                        right: 12px;
                        top: 6px;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 30px;
                    }
                    .name{
                        cursor: pointer;
                        margin-top: 30px;
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    p{
                        cursor: pointer;
                        margin-top: 4px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                    }
                }
                .item:nth-of-type(3n){
                    margin-right: 0;
                }
                .item:nth-of-type(2n){
                    margin-right: 0;
                }
                .item:hover{
                    p, h4, h5, span{
                        cursor: pointer;
                    }
                    cursor: pointer;
                    background: #F6F4EB;
                }
            }
            .load-more{
                cursor: pointer;
                margin: 0 auto;
                padding: 15px 50px;
                font-weight: 500;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                letter-spacing: 0.04em;
                color: #FFFFFF;
                background: #568357;
                box-shadow: 5px 10px 20px rgba(53, 110, 173, 0.2);
                border-radius: 10px;
            }
        }
    }
</style>


